import { useMemo } from 'react';

import { useQuery } from '@zenbusiness/application-commons-graphql';

import useAccountDetails from '#client/hooks/useAccountDetails';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { GET_APPLICATION_QUERY } from '#client/queries';

export default function useCardAddress() {
  const { businessEntityUuid } = useConstBusinessEntityUuid();

  const {
    loading,
    error,
    errors,
    data: applicationResponseData
  } = useQuery(GET_APPLICATION_QUERY, {
    noThrow: true,
    variables: {
      input: {
        businessUuid: businessEntityUuid
      }
    }
  });
  useLogError(errors, error);

  const personalAddress = useMemo(
    () => applicationResponseData?.application?.accountOwner?.address ?? {},
    [applicationResponseData]
  );

  const { bankCustomerAddress: accountAddress } = useAccountDetails();
  const businessAddress = useMemo(
    () => ({
      street: accountAddress.address1,
      street2: accountAddress.address2,
      city: accountAddress.city,
      state: accountAddress.state,
      postalCode: accountAddress.zip,
      country: accountAddress.country || 'US'
    }),
    [accountAddress]
  );

  return {
    businessAddress,
    personalAddress,
    loading,
    error
  };
}
